import styled from 'styled-components';

export const CustomColumnsWrapper = styled.div`
  padding: 1.25rem;
  width: 850px;
  max-width: 100%;
  box-sizing: border-box;
  color: ${(p) => p.theme.colors.text};
  display: grid;
  gap: 1.25rem;
  font-size: 0.9rem;

  * { box-sizing: border-box; }
  p, h3 { margin: 0; }
  h3 { font-size: 1rem; }
  .muted, small { color: ${(p) => p.theme.colors.textLight}; line-height: 1.5; }
  .heading { display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
  .form-fields { display: grid; grid-template-columns: 1fr 160px; gap: 1rem; }
  label { display: grid; gap: 0.5rem; font-weight: 500; min-width: 0; }
  input, select {
    border: 1px solid ${(p) => `${p.theme.colors.onSurface}25`};
    border-radius: 0.5rem; padding: 0.65rem; min-width: 0; width: 100%;
    background: ${(p) => p.theme.colors.surface}; color: inherit; font: inherit;
  }
  input:focus, select:focus, button:focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.primary}; outline-offset: 2px;
  }
  button { font: inherit; cursor: pointer; }
  button:disabled { opacity: 0.45; cursor: not-allowed; }
  .workspace { display: grid; grid-template-columns: 240px minmax(0, 1fr); gap: 1rem; }
  .field-picker, .composer, .saved-list {
    border: 1px solid ${(p) => `${p.theme.colors.onSurface}18`};
    border-radius: 0.75rem; padding: 1rem; min-width: 0;
    display: flex; flex-direction: column; gap: 0.75rem;
  }
  .available-fields { display: flex; flex-direction: column; gap: 0.4rem; max-height: 230px; overflow-y: auto; }
  .available-field {
    text-align: left; display: flex; align-items: center; gap: 0.4rem;
    border: 1px solid ${(p) => `${p.theme.colors.primary}25`}; border-radius: 0.45rem;
    padding: 0.55rem; background: ${(p) => `${p.theme.colors.primary}08`}; color: inherit;
    cursor: grab;
  }
  .available-field:hover { background: ${(p) => `${p.theme.colors.primary}18`}; }
  .available-field svg { flex-shrink: 0; }
  .available-field small { margin-left: auto; font-size: 0.7rem; }
  .value-editor {
    display: flex; align-items: center; flex-wrap: wrap; gap: 0.2rem; min-height: 100px;
    align-content: flex-start; padding: 0.65rem; border-radius: 0.6rem;
    border: 1px solid ${(p) => `${p.theme.colors.onSurface}30`};
    background: ${(p) => p.theme.colors.surface}; overflow-wrap: anywhere;
  }
  .value-editor:focus-within { border-color: ${(p) => p.theme.colors.primary}; }
  input.value-text { border: 0; outline: none; padding: 0.4rem 0; background: transparent; max-width: 100%; }
  .field-card {
    display: inline-flex; align-items: center; gap: 0.3rem; border-radius: 0.4rem;
    background: ${(p) => `${p.theme.colors.primary}16`}; color: ${(p) => p.theme.colors.primary};
    border: 1px solid ${(p) => `${p.theme.colors.primary}30`}; padding: 0.3rem 0.4rem;
    font-size: 0.78rem; max-width: 100%; overflow-wrap: anywhere;
  }
  .field-card button, .icon-button {
    display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
    background: transparent; color: inherit; border: 0; border-radius: 0.35rem; padding: 0.3rem;
  }
  .field-card button:hover, .icon-button:hover { background: ${(p) => `${p.theme.colors.onSurface}12`}; }
  .preview { border-radius: 0.5rem; padding: 0.8rem; background: ${(p) => `${p.theme.colors.primary}08`}; }
  .preview strong { display: block; margin-top: 0.3rem; overflow-wrap: anywhere; white-space: pre-wrap; }
  .error { color: ${(p) => p.theme.colors.negative}; font-size: 0.82rem; line-height: 1.5; }
  .text-button {
    color: ${(p) => p.theme.colors.primary}; background: transparent; border: 0;
    font-size: 0.8rem; padding: 0.25rem;
  }
  .primary-button {
    border: 0; border-radius: 0.5rem; padding: 0.65rem 1rem; align-self: flex-end;
    color: ${(p) => p.theme.colors.onPrimary}; background: ${(p) => p.theme.colors.primary};
  }
  .saved-columns { max-height: 180px; overflow-y: auto; }
  .saved-column { display: flex; gap: 0.75rem; align-items: center; padding: 0.75rem 0; }
  .saved-column + .saved-column { border-top: 1px solid ${(p) => `${p.theme.colors.onSurface}12`}; }
  .saved-column > div { flex: 1; min-width: 0; overflow-wrap: anywhere; }
  .saved-column small { display: block; }
  .empty { padding: 1rem 0; text-align: center; }
  .status { color: ${(p) => p.theme.colors.positive}; font-size: 0.82rem; }
  @media (max-width: 650px) {
    padding: 0.8rem;
    .workspace, .form-fields { grid-template-columns: minmax(0, 1fr); }
    .available-fields { max-height: 160px; }
  }
`;
